/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { IMessage } from "./abstract-message.service";

export class RenewHeartBeatEvent implements IMessage {
   public static readonly MSG_TYPE = "RenewHeartBeat";
   public type: string = RenewHeartBeatEvent.MSG_TYPE;
}

export class CanvasEvent implements IMessage {
   public static readonly MSG_TYPE = "CanvasEvent";
   public type: string = CanvasEvent.MSG_TYPE;
   public show: boolean;
   constructor(show: boolean) {
      this.show = show;
   }
}
